<template>
  <div>
    <basic-menu/>
    <section
      :class="layoutBackground"
      class="section main-section has-light-background">
      <div class="container">
        <transition
          name="fade"
          mode="out-in">
          <router-view :key="$route.fullPath"/>
        </transition>
      </div>
    </section>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    name: 'LoggedInLayout',
    computed: mapGetters(["layoutBackground"])
  };
</script>

<style>
  .fade-leave-active {
    transition-duration: .1s
  }
  .fade-enter-active {
    transition-duration: .1s
  }

  .main-section {
    min-height: calc(100vh - 3.25rem);
    transition: background-color .3s ease;
  }
</style>



// WEBPACK FOOTER //
// src/components/LoggedInLayout.vue